var l=l=>null==l;export{l as isNil};
//# sourceMappingURL=is-nil.js.map
